import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function BundleSection() {
  const [openAccordion, setOpenAccordion] = useState<number | null>(null);
  const toggleAccordion = (index: number) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };
  const products = [{
    title: 'Método DOG-CALM: El Sistema Paso a Paso',
    value: 'Valor: 67€',
    isCore: true
  }, {
    title: 'PLAN DE LLUVIA',
    text: 'Quema su energía en 10 min en el salón cuando el cielo se cae.',
    value: 'Valor: 17€',
    isBonus: true,
    accordionTitle: '¿Qué incluye este protocolo de emergencia?',
    accordionContent: <div className="space-y-3 text-sm text-white/80" data-id="element-18">
          <p data-id="element-19">
            No es solo 'jugar'. Es un sistema de estimulación olfativa y
            cognitiva diseñado para cansar el cerebro de tu perro cuando el
            clima no acompaña.
          </p>
          <p data-id="element-20">
            <strong className="text-white" data-id="element-21">
              El Juego de los 120 segundos:
            </strong>{' '}
            Cómo bajar sus pulsaciones usando solo una toalla y 3 premios.
          </p>
          <p data-id="element-22">
            <strong className="text-white" data-id="element-23">Cansancio Residual:</strong> Por qué
            10 minutos de este plan equivalen a 1 hora de carrera continua.
          </p>
          <p data-id="element-24">
            <strong className="text-white" data-id="element-25">Resultado:</strong> Un perro que
            duerme plácidamente en el salón aunque fuera truene.
          </p>
        </div>
  }, {
    title: 'LA DIETA DEL FOCO',
    text: 'Los 5 alimentos secretos que lo hipnotizan para que solo te mire a ti.',
    value: 'Valor: 12€',
    isBonus: true,
    accordionTitle: "El secreto de la 'Hiper-Conexión' visual:",
    accordionContent: <div className="space-y-3 text-sm text-white/80" data-id="element-26">
          <p data-id="element-27">
            Descubre la lista de super-alimentos de supermercado que actúan como
            'moneda de alta denominación' para tu perro.
          </p>
          <p data-id="element-28">
            <strong className="text-white" data-id="element-29">El Hack de la Dopamina:</strong> Qué
            alimentos activan su atención de forma natural sin usar químicos.
          </p>
          <p data-id="element-30">
            <strong className="text-white" data-id="element-31">La Regla del 80/20:</strong> Cómo
            usar premios mediocres para callejear y premios 'TOP' para
            situaciones críticas (perros reactivos o ruidos fuertes).
          </p>
          <p data-id="element-32">
            <strong className="text-white" data-id="element-33">Resultado:</strong> Tu perro te
            mirará a ti ignorando el resto del mundo.
          </p>
        </div>
  }, {
    title: 'EL PERRO CAFETERO',
    text: 'El arte de la calma absoluta en bares y terrazas.',
    value: 'Valor: 17€',
    isBonus: true,
    accordionTitle: 'Tu pasaporte a la libertad social:',
    accordionContent: <div className="space-y-3 text-sm text-white/80" data-id="element-34">
          <p data-id="element-35">
            El protocolo para que tu perro pase de ser una 'molestia' a ser
            invisible en lugares públicos.
          </p>
          <p data-id="element-36">
            <strong className="text-white" data-id="element-37">La Señal de 'Desconexión':</strong>{' '}
            El comando mudo para que se tumbe y se relaje bajo cualquier mesa.
          </p>
          <p data-id="element-38">
            <strong className="text-white" data-id="element-39">Gestión de Estímulos:</strong> Qué
            hacer cuando un niño se acerca o el camarero pasa corriendo.
          </p>
          <p data-id="element-40">
            <strong className="text-white" data-id="element-41">Resultado:</strong> Recupera tus
            cenas, cafés y vida social con tu perro durmiendo a tus pies.
          </p>
        </div>
  }];
  return <section className="py-12 px-5" data-id="element-42">
      <div className="max-w-lg mx-auto" data-id="element-43">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center mb-8 leading-tight" data-id="element-44">
          Todo lo que recibes hoy por menos de lo que cuesta un café y una
          tostada:
        </h2>

        {/* Unified Mockup Image */}
        <div className="w-full mb-4 relative" data-id="element-45">
          <img src="https://cdn.magicpatterns.com/uploads/jbKKtR8zYbHRy1zEq9N1tf/mockup_nuevo.png" alt="El pack completo DOG-CALM" className="w-full h-auto rounded-xl" data-id="element-46" />
        </div>
        <p className="text-white/50 text-sm text-center mb-8 font-medium" data-id="element-47">
          El pack completo tal y como lo recibes hoy.
        </p>

        {/* Product list cards — text only */}
        <div className="flex flex-col gap-4 mb-6" data-id="element-48">
          {products.map((product, index) => <div key={index} className={`rounded-2xl p-5 flex flex-col ${product.isCore ? 'glass-teal border-teal/40 shadow-[0_0_15px_rgba(45,212,191,0.1)]' : 'glass'}`} data-id="element-49">
              <div className="flex items-start justify-between gap-3" data-id="element-50">
                <div className="flex-1" data-id="element-51">
                  <h3 className="text-lg font-bold text-white mb-1 tracking-tight" data-id="element-52">
                    {product.title}
                  </h3>
                  {product.text && <p className="text-white/70 text-sm leading-relaxed" data-id="element-53">
                      {product.text}
                    </p>}
                </div>
                <div className="flex flex-col items-end flex-shrink-0" data-id="element-54">
                  <p className={`font-medium text-sm ${product.isBonus ? 'text-white/50 line-through' : 'text-teal font-bold'}`} data-id="element-55">
                    {product.value}
                  </p>
                  {product.isBonus && <span className="bg-accent text-white text-[10px] font-bold px-2 py-0.5 rounded-full mt-1" data-id="element-56">
                      GRATIS
                    </span>}
                </div>
              </div>

              {/* Accordion for Bonus Cards */}
              {product.isBonus && product.accordionTitle && <div className="mt-4 pt-4 border-t border-white/10" data-id="element-57">
                  <button onClick={() => toggleAccordion(index)} className="w-full flex items-center justify-between text-left focus:outline-none group" data-id="element-58">
                    <span className="text-sm font-semibold text-white/90 group-hover:text-white transition-colors" data-id="element-59">
                      {product.accordionTitle}
                    </span>
                    <ChevronDown className={`w-4 h-4 text-white/50 transition-transform duration-300 ${openAccordion === index ? 'rotate-180 text-white' : ''}`} data-id="element-60" />
                  </button>
                  <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openAccordion === index ? 'max-h-[500px] opacity-100 mt-4' : 'max-h-0 opacity-0'}`} data-id="element-61">
                    <div className="p-4 rounded-xl bg-white/5 border border-white/5" data-id="element-62">
                      {product.accordionContent}
                    </div>
                  </div>
                </div>}
            </div>)}
        </div>

        {/* Value Summary */}
        <div className="glass-strong rounded-2xl p-8 text-center border-teal/30" data-id="element-63">
          <p className="text-white/50 font-medium line-through mb-2" data-id="element-64">
            VALOR TOTAL DEL PACK: 113€
          </p>
          <p className="text-3xl md:text-4xl font-black text-accent tracking-tight" data-id="element-65">
            PRECIO HOY: 9,95€
          </p>
        </div>
      </div>
    </section>;
}